import { render } from "./org-name-now.vue?vue&type=template&id=36a76bbc"
import script from "./org-name-now.vue?vue&type=script&lang=ts"
export * from "./org-name-now.vue?vue&type=script&lang=ts"

import "./org-name-now.vue?vue&type=style&index=0&id=36a76bbc&lang=less"
script.render = render

export default script